<template>
  <div
    class="reader"
    :class="{active: false}"
    v-show="visible"
    @click="clickReader"
  >
    <div class="figure">
      <img
        :src="$handleAssetsUrl(item.iconUrl)"
        alt
      />
    </div>
    <div class="content">
      <div class="row">
        <div class="label">{{label}}</div>
        <div
          class="preview"
          @click.stop="onClickPreview"
        >
          <iconfont
            name="#iconyinku-yulanbofang"
            font-size="18px"
          ></iconfont>
          <audio
            ref="audio"
            style="width: 0; height: 0;"
            :src="$handleAssetsUrl(item.preview)"
          ></audio>
        </div>
      </div>
      <div class="row desc">{{item.description}}</div>
    </div>
  </div>
</template>

<script>
import readerBus from './readerBus.js';
export default {
  props: {
    label: {
      type: String
    },
    value: {
      type: String
    },
    active: {
      type: Boolean
    },
    item: {
      type: Object
    }
  },
  name: 'Reader',
  components: {
    iconfont: () => import('@/platformCode/iconfont')
  },
  data () {
    return {

    }
  },
  computed: {
    visible () {
      if (this.$parent.activeTab == '') {
        return true
      }
      let v = (this.item.category || '').split(',').indexOf(this.$parent.activeTab) > -1;
      return v;
    }
  },
  methods: {
    clickReader () {
      readerBus.$emit('clickReader', {
        value: this.value
      })
    },
    onClickPreview () {
      readerBus.$emit('clickPreview', {
        value: this.value
      });
      this.$parent.stopPreview();
      this.$refs.audio && this.$refs.audio.play().catch(e => {
        this.$message({
          message: `音库试听失败，请稍后再试`,
          type: "error"
        });
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.reader {
  flex-shrink: 0;
  display: flex;
  width: 224px;
  height: 87px;
  background: #f9f9ff;
  border-radius: 4px;
  margin-left: 12px;
  margin-top: 12px;
  cursor: pointer;
  padding-right: 20px;
  &:hover {
    box-shadow: 0px 2px 10px 0px rgba(96, 98, 121, 0.15);
  }
}
.figure {
  flex-grow: 0;
  flex-shrink: 0;
  margin-top: 16px;
  margin-left: 20px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  overflow: hidden;
}
.content {
  margin-top: 16px;
  margin-left: 8px;
  padding-top: 3px;
}
.row {
  display: flex;
  align-items: center;
  color: #333333;
  & .label {
    line-height: 1;
    margin-right: 12px;
  }
  & .preview {
    height: 18px;
  }
}
.row.desc {
  font-size: 12px;
  color: #606266;
  margin-top: 6px;
  text-align: left;
}
.active {
  border: 1px solid #5778fb;
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/generateVoice/reader.vue